import { render, staticRenderFns } from "./lastAchievement.vue?vue&type=template&id=0cb004aa&scoped=true&"
import script from "./lastAchievement.vue?vue&type=script&lang=js&"
export * from "./lastAchievement.vue?vue&type=script&lang=js&"
import style0 from "./lastAchievement.vue?vue&type=style&index=0&id=0cb004aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb004aa",
  null
  
)

export default component.exports